import { useMemo } from "react";
import { buildPortalNavigation } from "../config/portalFeatureNav";
import useWorkspaceAccess from "./useWorkspaceAccess";
import { clearAuthCaches } from "../utils/authCache";

export function clearPortalFeaturesCache() {
  clearAuthCaches();
}

export default function usePortalFeatures() {
  const { features, loading, reload, workspaceReady } = useWorkspaceAccess();

  const navigation = useMemo(
    () => buildPortalNavigation(features),
    [features],
  );

  return {
    features,
    navigation,
    loading: loading || !workspaceReady,
    reload,
  };
}
